import { toast } from "sonner";

export const APP_SCREENS = {
  dashboard: "https://static.prod-images.emergentagent.com/jobs/aecc7b56-51de-4342-9065-750f4ba35aec/images/3850a30a166fa0a91a0ebc3bacd617d7d6083a23749b99f34e6cdbe41e45930c.jpeg",
  proposal: "https://static.prod-images.emergentagent.com/jobs/aecc7b56-51de-4342-9065-750f4ba35aec/images/43425a2c46c82bc1d9f369dee3d461018a6470e5805b30aca867d8754694c10c.jpeg",
  sent: "https://static.prod-images.emergentagent.com/jobs/aecc7b56-51de-4342-9065-750f4ba35aec/images/eb04e2d1f0553a9a7151c0f192d628e5f33a77b7dfcf5231cd14ec69a84651b4.jpeg",
  newOpportunity: "https://static.prod-images.emergentagent.com/jobs/aecc7b56-51de-4342-9065-750f4ba35aec/images/801017546b71687e713c00bf4539fe70701bb49fdb22cdc8f000434c7458595e.jpeg",
};

export const triggerDownload = () => {
  toast("Application bientôt disponible 🚀", {
    description: "Leadzi CHR arrive très prochainement sur l'App Store et Google Play. Reviens vite !",
  });
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};
